
export const toggleTopItem=(value)=>{
    return (dispatch,getState)=>{
        dispatch({
            type:'TOGGLE_TOP_ITEM',
            value
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/salesLoader/topItemsAction.js